module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Menu":{"integrator":"Integrator","invoices":"Invoices","deliveries":"Deliveries"}},"es":{"Menu":{"integrator":"Integraciones","invoices":"Facturas","deliveries":"Envíos"}}}')
  delete Component.options._Ctor
}
